<!--
 * @Description: 出场检验
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-04 15:44:01
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <el-form ref="form" inline :model="tableParam" label-width="100px">
                  <el-form-item label="站点">
                    <el-select ref="selection" v-model="tableParam.stationId" style="width: 150px;" filterable>
                      <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="检测录入时间">
                    <el-date-picker v-model="tableParam.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"> </el-date-picker>
                  </el-form-item>
                  <el-form-item label="取样时间">
                    <el-date-picker v-model="tableParam.time2" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"> </el-date-picker>
                  </el-form-item>
                  <el-form-item label="试块编号">
                    <el-input v-model="tableParam.code" style="width: 180px" placeholder="请输入"
                      @keyup.enter.native="searchSubmit()"></el-input>
                  </el-form-item>
                  <el-form-item label="工程名称">
                    <el-input v-model="tableParam.engineeringName" style="width: 180px" placeholder="请输入"
                      @keyup.enter.native="searchSubmit()"></el-input>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="tableParam.detectionStatus" clearable style="width: 100px" placeholder="请选择">
                      <el-option label="已检测" :value="1"></el-option>
                      <el-option label="待取样" :value="0"></el-option>
                      <el-option label="待检测" :value="2"></el-option>
                      <el-option label="审批中" :value="3"></el-option>
                      <el-option label="未通过" :value="4"></el-option>
                      <el-option label="已撤销" :value="5"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="searchSubmit()">查
                      询</el-button>
                  </el-form-item>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                    置</el-button>
                  <el-button size="medium" class="bottom_three" style="margin-left: 12px" @click="downLoad()">导
                    出</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px"
                    @click="tableParamType = true">高级搜索</el-button>
                  <el-button size="medium" class="bottom_three" style="margin-left: 12px"
                    @click="downLoad2()">导出已抗压</el-button>
                </el-form>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :height="screenHeight - 460" :data="tableData" tooltip-effect="dark">
                <el-table-column prop="detectionStatus" label="状态" fixed="left">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.detectionStatus === 1" type="success">已检验</el-tag>
                    <el-tag v-else-if="scope.row.detectionStatus === 0" type="danger">待取样</el-tag>
                    <el-tag v-else-if="scope.row.detectionStatus === 3" style="cursor: pointer" type="success"
                      @click="handleToCenterTask">审批中</el-tag>
                    <el-tag v-else-if="scope.row.detectionStatus === 4" type="success">未通过</el-tag>
                    <el-tag v-else-if="scope.row.detectionStatus === 5" type="success">已撤销</el-tag>
                    <el-tag v-else type="warning">待检验</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="code" label="试块编号" width="150" fixed="left"></el-table-column>
                <el-table-column prop="station" label="生产站点" width="100"></el-table-column>
                <el-table-column prop="proLine" label="生产线" width="auto"></el-table-column>
                <el-table-column prop="field1" label="取样时间"></el-table-column>
                <el-table-column prop="detectionTime" label="检验录入时间"></el-table-column>
                <!-- <el-table-column prop="customerName" width="200" label="客户名称"></el-table-column> -->
                <el-table-column prop="engineeringName" width="200" label="工程名称"></el-table-column>
                <el-table-column prop="pouringPart" label="浇筑部位" width="200"></el-table-column>
                <el-table-column prop="product" label="产品名称" width="auto"></el-table-column>

                <el-table-column prop="carNo" width="120" label="运输车辆"></el-table-column>
                <el-table-column prop="mixMession" label="配合比">
                  <template slot-scope="scope">
                    <span  class="table_link" @click="lookMix(scope.row.mixMession)">查看</span>
                  </template>
                </el-table-column>
                <el-table-column prop="threeCompression" label="3天抗压">
                  <template slot-scope="scope">
                    <span  class="table_link" @click="pressureDataOpen(scope.row, 3)">{{
                      scope.row.threeCompression }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sevenCompression" label="7天抗压">
                  <template slot-scope="scope">
                    <span class="table_link" @click="pressureDataOpen(scope.row, 7)">{{
                      scope.row.sevenCompression }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="fourteenCompression" label="14天抗压">
                  <template slot-scope="scope">
                    <span class="table_link"
                      @click="pressureDataOpen(scope.row, 14)">{{ scope.row.fourteenCompression }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="twentyEightcompression" label="28天抗压">
                  <template slot-scope="scope">
                    <span class="table_link"
                      @click="pressureDataOpen(scope.row, 28)">{{ scope.row.twentyEightcompression }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sixtycompression" label="60天抗压">
                  <template slot-scope="scope">
                    <span class="table_link"
                      @click="pressureDataOpen(scope.row, 60)">{{ scope.row.sixtycompression }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="" label="代表数"></el-table-column>
                <el-table-column prop="" label="抽样组"></el-table-column>
                <el-table-column prop="" label="检测方式"></el-table-column> -->
                <el-table-column prop="slump" label="坍落度"></el-table-column>
                <el-table-column prop="slumpOneHour" label="1h坍落度"></el-table-column>
                <el-table-column prop="slumpTwoHour" label="2h坍落度"></el-table-column>
                <el-table-column prop="expansibility" label="扩展性"></el-table-column>
                <el-table-column prop="expansibilityOneHour" label="1h扩展性"></el-table-column>
                <el-table-column prop="expansibilityTwoHour" label="2h扩展性"></el-table-column>
                <el-table-column prop="workabilityEvaluation" label="和易性评价"></el-table-column>
                <el-table-column prop="workabilityDescribe" label="和易性描述"></el-table-column>
                <el-table-column label="和易性图片">
                  <template slot-scope="scope">
                    <span class="table_link" @click="handleVideo(scope.row.videoUrl)">查看</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="" label="温度"></el-table-column>
                <el-table-column prop="" label="湿度"></el-table-column> -->
                <el-table-column prop="sizeValue" label="试件尺寸">
                  <template slot-scope="scope">
                    <span v-if="scope.row.buildSize == 2">150mm*150mm*150mm</span>
                    <span v-else-if="scope.row.buildSize == 3">70.7mm*70.7mm*70.7mm</span>
                    <span v-else>100mm*100mm*100mm</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="" label="取样人"></el-table-column> -->
                <el-table-column prop="inspector" label="检验人"></el-table-column>
                <el-table-column prop="remark" label="备注信息">
                  <template slot-scope="scope">
                    <span v-if="scope.row.remark" class="table_link" @click="changeRemark(scope.row)">{{ scope.row.remark
                    }}</span>
                    <span v-else class="table_link" @click="changeRemark(scope.row)">填写</span>
                  </template>
                </el-table-column>
                <el-table-column prop="logisticsNo" width="auto" label="物流单号"></el-table-column>
                <el-table-column prop="logisticsNo" width="100" fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.detectionStatus == '0' && ButtonList.findIndex(res => res.buttonValue == 'QUYANG') !== -1"
                      style="margin: 5px 0" class="bottom_one" size="mini" @click="checkOutOpen(scope.row)">
                      取样
                    </el-button>

                    <el-button
                      v-if="(scope.row.detectionStatus == '2' || scope.row.detectionStatus == '4' || scope.row.detectionStatus == '5') && ButtonList.findIndex(res => res.buttonValue == 'JIANCELR') !== -1"
                      style="margin: 5px 0" class="bottom_one" size="mini" @click="checkOutIn(scope.row)">
                      检测录入
                    </el-button>
                    <el-button v-if="scope.row.detectionStatus == '1' || scope.row.detectionStatus == '2'"
                      style="margin: 5px 0" class="bottom_one" size="mini" @click="printTag(scope.row)"> 打印标签 </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 视频查看 -->
    <el-dialog v-dialogDrag :visible.sync="Dialog1" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">图片信息</span>
      <div class="dialoginfo">
        <div>
          <el-image v-for="(item, index) in arr1" :key="index"
            style="width: 200px; height: 200px; margin: 0 10px 10px 10px; border-radius: 4px" :src="item"
            :preview-src-list="arr1" :z-index="10000"></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="Dialog1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 备注修改 -->
    <el-dialog v-dialogDrag :visible.sync="remarkDig" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">备注</span>
      <div class="dialoginfo">
        <div>
          <span>备注</span>
          <el-input v-model="remarkText" placeholder="请填写备注" class="textarea" type="textarea" resize="none"
            rows="5"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="remarkDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveRemark()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 手动录入抗压数据 -->
    <el-dialog v-dialogDrag :visible.sync="pressureDataDig" width="780px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ pressureDataForm.timeDifference }}天抗压数据</span>
      <div>
        <el-form ref="pressureDataForm" :inline="true" :model="pressureDataForm" label-width="110px"
          :rules="pressureDataRules">
          <el-form-item label="荷载1:" prop="value1">
            <el-input v-model="pressureDataForm.value1" :disabled="low.whetherInput !== 1" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="强度1:">
            <span>{{pressureDataForm.test01}}</span>
          </el-form-item>
          <el-form-item label="荷载2:" prop="value2">
            <el-input v-model="pressureDataForm.value2" :disabled="low.whetherInput !== 1" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="强度2:">
            <span>{{pressureDataForm.test02}}</span>
          </el-form-item>
          <el-form-item label="荷载3:" prop="value3">
            <el-input v-model="pressureDataForm.value3" :disabled="low.whetherInput !== 1" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="强度3:">
            <span>{{pressureDataForm.test03}}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="pressureDataDig = false">关 闭</el-button>
        <el-button v-if="low.whetherInput == 1" class="bottom_all" @click="savePressureData">提交录入</el-button>
      </span>
    </el-dialog>
    <!-- 检测录入及查看 -->
    <el-dialog v-dialogDrag :visible.sync="visible" width="1050px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ `检测${readOnly ? "查看" : "录入"}` }}</span>
      <div>
        <!-- <div class="dialoginfo-title">
          <div>
            <span>站点：</span>
            <span>{{ checkOutData.station }}</span>
          </div>
          <div>
            <span>工程名称：</span>
            <span>{{ checkOutData.engineeringName }}</span>
          </div>
          <div>
            <span>产品名称：</span>
            <span>{{ checkOutData.product }}</span>
          </div>
          <div>
            <span>车牌号：</span>
            <span>{{ checkOutData.carNo }}</span>
          </div>
        </div> -->
        <el-form ref="checkInForm" :inline="true" :model="checkInForm" label-width="110px" :rules="rules">
          <el-form-item label="坍落度" prop="slump">
            <el-input v-model="checkInForm.slump" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="1h坍落度">
            <el-input v-model="checkInForm.slumpOneHour" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="2h坍落度">
            <el-input v-model="checkInForm.slumpTwoHour" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="扩展性" prop="expansibility">
            <el-input v-model="checkInForm.expansibility" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="1h扩展性">
            <el-input v-model="checkInForm.expansibilityOneHour" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="2h扩展性">
            <el-input v-model="checkInForm.expansibilityTwoHour" style="width: 215px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="和易性评价" prop="workabilityEvaluation">
            <el-select v-model="checkInForm.workabilityEvaluation" style="width: 215px" placeholder="请选择">
              <el-option v-for="(item, index) in evaluation" :key="index" :label="item.value" :value="item.id * 1"
                @click.native="checkInForm.workabilityEvaluationId = item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="workabilityDescribe">
            <span slot="label">和易性描述</span>
            <el-input v-model="checkInForm.workabilityDescribe" :rows="1" style="width: 550px" type="textarea"
              placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">和易性照片</span>
            <FileComponent fileCode="checkInImg" :files="listFilesa" @deleteFile="deleteFile"
              @uplodeSuccess="uplodeSuccess" />
          </el-form-item>
          <el-form-item>
            <span slot="label">备注：</span>
            <el-input v-model="checkInForm.remark" :disabled="readOnly" type="textarea" :rows="2" style="width: 885px"
              placeholder="请输入内容"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="visible = false">取 消</el-button>
        <el-button v-if="!readOnly" class="bottom_all" @click="checkInSubmit">提交录入</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :close-on-click-modal="false" title="结果判断" :visible.sync="dialogVisible" width="40%">
      <div v-if="result">系统检测结果为： OK</div>
      <div v-else>系统检测结果为： NG</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="result" class="bottom_all" type="primary" @click="handleSure">确 定</el-button>
        <el-button v-show="!result" class="bottom_all" type="primary" @click="handleToFlow">进入审核</el-button>
      </span>
    </el-dialog>
    <!-- 高级搜索 -->
    <el-dialog v-dialogDrag :visible.sync="tableParamType" width="650px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo">
        <el-form ref="reftableParam" :inline="true" :model="tableParam" label-width="110px">
          <el-form-item>
            <span slot="label">物流单号</span>
            <el-input v-model="tableParam.logisticsNo" tplaceholder="请输入" clearable style="width: 400px"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">交货车辆</span>
            <el-input v-model="tableParam.carNo" tplaceholder="请输入" clearable style="width: 400px"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">检验人</span>
            <el-input v-model="tableParam.inspector" tplaceholder="请输入" clearable style="width: 400px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two"
          @click="(tableParamType = false), (tableParam.logisticsNo = ''), (tableParam.carNo = ''), (tableParam.inspector = '')">取
          消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="gettableData(), (tableParamType = false)">搜
          索</el-button>
      </span>
    </el-dialog>
    <!-- 取样弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="checkOutDig" width="780px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">取样</span>
      <div class="dialoginfo">
        <el-form ref="checkOutForm" :inline="true" :model="checkOutForm" label-width="110px">
          <el-form-item>
            <span slot="label">构件尺寸：</span>
            <el-select v-model="checkOutForm.buildSize">
              <el-option label="100mm*100mm*100mm" value="1"></el-option>
              <el-option label="150mm*150mm*150mm" value="2"></el-option>
              <el-option label="70.7mm*70.7mm*70.7mm" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">抗压检验：</span>
            <el-checkbox-group v-model="checkOutForm.checkId">
              <el-checkbox v-for="(item, index) in compressionTestList" :key="index" :label="item.id">{{ item.value
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="checkOutDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="makeupdStatusFun">保 存</el-button>
      </span>
    </el-dialog>
     <!-- 配合比弹窗 -->
     <el-dialog v-dialogDrag :visible.sync="mixMessionDig" width="780px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">配合比查看</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%"  :data="mixMessionData" tooltip-effect="dark">
                <el-table-column prop="name" label="材料名"></el-table-column>
                <el-table-column prop="useName" label="使用仓"></el-table-column>
                <el-table-column prop="value" label="配合比用量"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mixMessionDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" :imgList="imgList" :mp4List="mp4List" @reset="imgsDialog = false"></ShowDetails>

    <!-- 检测查看 -->
    <LookDialog :visible.sync="lookVisible" :config="lookConfig" />
    <!-- 取样标签打印 -->
    <tagPrint ref="tagPrint" :data="printData" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { concreteQueryPage, Download, concreteSaveResult, savePressureData, addOrUpdateRemark, exportPressureData, queryPressureData } from "@/api/smart/checkout.js";
// import { getStationNormByDetection, getCheckResult, saveCheckOutResult, makeupdStatus2, countCheckResult } from '@/api/smart/checkout';
import { saveCheckOutResult, makeupdStatus2 } from "@/api/smart/checkout";
import ShowDetails from "@/components/showdetails";
import LookDialog from "./flowcomponent/LookDialog";
import tagPrint from "./flowcomponent/tagPrint";
import FileComponent from "@/components/File/fileComponent";
import { getUserAutList } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth";
export default {
  mixins: [mixin],
  components: {
    ShowDetails,
    LookDialog,
    FileComponent,
    tagPrint,
  },
  data() {
    return {
      lookVisible: false,
      lookConfig: {},
      low: {},
      tableParamType: false,
      queryPage: concreteQueryPage,
      imgsDialog: false,
      imgList: [],
      mp4List: [],
      DownloadURL: Download,
      DownloadURL2: exportPressureData,
      Dialog1: false,
      pagesType: 0,
      arr1: [],
      checkOutData: { addedValue: "" },
      readOnly: false,
      visible: false,
      tableNav: [],
      dataSource: [],
      remark: "",
      checkOutType: [],
      checkType: "",
      dialogVisible: false,
      result: "",
      //取样弹窗
      checkOutDig: false,
      checkOutForm: {
        checkList: [],
        checkId: [3],
        buildSize: "1",
      },
      compressionTestList: [
        {
          value: "3天抗压",
          id: 0,
        },
        {
          value: "7天抗压",
          id: 1,
        },
        {
          value: "14天抗压",
          id: 2,
        },
        {
          value: "28天抗压",
          id: 3,
        },
        {
          value: "60天抗压",
          id: 4,
        },
      ],
      //检测录入弹窗
      checkInForm: {},
      //和易性评价
      evaluation: [
        { id: 1, value: "良好" },
        { id: 2, value: "一般" },
        { id: 3, value: "较差" },
      ],
      //坍落度
      slumps: [
        { id: 0, value: "160-180" },
        { id: 1, value: "190-210" },
        { id: 2, value: "220-240" },
        { id: 3, value: "250-270" },
      ],
      //手动录入抗压数据
      pressureDataForm: {
        detectionId: "",//检验id
        timeDifference: "",//龄期3 7 14 28 60
        value1: "",//荷载1
        value2: "",//荷载2
        value3: "",//荷载3
        test01: "",//强度1
        test02: "",//强度2
        test03: "",//强度3
      },
      pressureDataDig: false,
      pressureDataRules: {
        value1: [{ required: true, message: "请输入荷载1", trigger: "blur" }],
        value2: [{ required: true, message: "请输入荷载2", trigger: "blur" }],
        value3: [{ required: true, message: "请输入荷载3", trigger: "blur" }],
        // test01: [{ required: true, message: "请输入强度1", trigger: "blur" }],
        // test02: [{ required: true, message: "请输入强度2", trigger: "blur" }],
        // test03: [{ required: true, message: "请输入强度3", trigger: "blur" }],
      },
      rules: {
        slump: [{ required: true, message: "请输入坍落度", trigger: "blur" }],
        expansibility: [{ required: true, message: "请输入扩展性", trigger: "blur" }],
        workabilityDescribe: [{ required: true, message: "请输入和易性描述", trigger: "blur" }],
        workabilityEvaluation: [{ required: true, message: "请选择和易性评价", trigger: "change" }],
      },
      listFilesa: [],
      printData: [],
      UserInfo: "",
      stationIdlist: [],
      //修改备注
      remarkDig: false,
      remarkText: "",
      //配合比
      mixMessionData:[],
      mixMessionDig:false,
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.stationIdlist = await getUserAutList(true);
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, detectionTypeId: 5, logisticsNo: "", carNo: "", inspector: "", stationId: "", time: "", time2: "", code: "" };
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.stationId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.stationId = this.stationIdlist[0].id;
    }
    this.gettableData();
  },
  methods: {
    lookMix(mixMession){
      if(mixMession){
        this.mixMessionData = JSON.parse(mixMession)
        this.mixMessionDig = true
      } else {
        this.$message.warning('无数据!')
      }
    },
    changeRemark(row) {
      this.low = JSON.parse(JSON.stringify(row))
      this.remarkText = this.low.remark
      this.remarkDig = true
    },
    saveRemark() {
      let params = {
        id: this.low.id,
        remark: this.remarkText
      }
      addOrUpdateRemark(params).then(res => {
        if (res.code == 1001) {
          this.$message.success('保存成功！')
          this.gettableData()
          this.remarkDig = false
        }
      })
    },
    downLoad() {
      this.$Download(this.DownloadURL, this.tableParam);
    },
    downLoad2() {
      this.$Download(this.DownloadURL2, this.tableParam);
    },
    //手动录入抗压数据
    pressureDataOpen(row, timeDifference) {
      this.low = JSON.parse(JSON.stringify(row))
      queryPressureData({ detectionCode: this.low.code, timeDifference: timeDifference }).then(res => {
        if (res.code == 1001) {
          if(!res.data){
          this.pressureDataForm = this.$options.data().pressureDataForm
          this.pressureDataForm.detectionId = row.id
          this.pressureDataForm.timeDifference = timeDifference
          } else {
            this.pressureDataForm =res.data
            this.pressureDataForm.value1 = res.data.kn1
            this.pressureDataForm.value2 = res.data.kn2
            this.pressureDataForm.value3 = res.data.kn3
            this.pressureDataForm.timeDifference = timeDifference
          }
          this.pressureDataDig = true
          setTimeout(() => {
            this.$refs.pressureDataForm.clearValidate();
          }, 10);
        }
      })

    },
    savePressureData() {
      this.$refs['pressureDataForm'].validate((valid) => {
        if (valid) {
          savePressureData(this.pressureDataForm).then(res => {
            if (res.code == 1001) {
              this.$message.success('保存成功！')
              this.pressureDataDig = false
              this.gettableData();
            }
          })
        } else {
          return false;
        }
      });

    },
    //取样标签打印
    printTag(row) {
      let obj = {
        code: row.code,
        product: row.product,
        field1: row.field1,
        engineeringName: row.engineeringName,
        pouringPart: row.pouringPart,
        age: "",
      };
      let arr = [];
      let number = [1, 2, 3];
      if (row.threeCompression) {
        number.forEach(item => {
          let obj1 = JSON.parse(JSON.stringify(obj));
          this.$set(obj1, "age", "3");
          this.$set(obj1, "sort", item);
          arr.push(obj1);
        });
      }
      if (row.sevenCompression) {
        number.forEach(item => {
          let obj2 = JSON.parse(JSON.stringify(obj));
          this.$set(obj2, "age", "7");
          this.$set(obj2, "sort", item);
          arr.push(obj2);
        });
      }
      if (row.fourteenCompression) {
        number.forEach(item => {
          let obj3 = JSON.parse(JSON.stringify(obj));
          this.$set(obj3, "age", "14");
          this.$set(obj3, "sort", item);
          arr.push(obj3);
        });
      }
      if (row.twentyEightcompression) {
        number.forEach(item => {
          let obj4 = JSON.parse(JSON.stringify(obj));
          this.$set(obj4, "age", "28");
          this.$set(obj4, "sort", item);
          arr.push(obj4);
        });
      }
      if (row.sixtycompression) {
        number.forEach(item => {
          let obj5 = JSON.parse(JSON.stringify(obj));
          this.$set(obj5, "age", "60");
          this.$set(obj5, "sort", item);
          arr.push(obj5);
        });
      }
      this.printData = arr;
      console.log(this.printData);
      if (this.printData.length > 0) {
        this.$refs.tagPrint.print();
      } else {
        this.$message.warning("无数据");
      }
    },
    handleToCenterTask() {
      this.$router.push({ name: "iama" });
    },
    init() {
      this.tableParam.engineeringName = "";
      this.tableParam.code = "";
      this.tableParam.time = "";
      this.tableParam.time2 = "";
      this.tableParam.detectionStatus = "";
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.stationIdlist[0].id;
      }
      this.searchSubmit();
    },
    checkOutOpen(row) {
      this.low = row;
      this.checkOutForm = this.$options.data().checkOutForm;
      if(row.product.indexOf('砂浆') !== -1) {
        this.checkOutForm.buildSize = '3'
      }
      this.checkOutDig = true;
    },
    makeupdStatusFun() {
      let arr = [];
      this.checkOutForm.checkId.forEach(item => {
        let obj = this.compressionTestList.find(item2 => item2.id == item);
        arr.push(obj);
      });
      this.checkOutForm.checkList = arr;
      let json = {
        id: this.low.id,
        detectionStatus: 2,
        buildSize: this.checkOutForm.buildSize,
        compressionTest: JSON.stringify(this.checkOutForm.checkList),
      };
      makeupdStatus2(json).then(res => {
        if (res.code == 1001) {
          this.$message.success("取样成功!");
          this.checkOutDig = false;
          this.searchSubmit();
        }
      });
    },
    searchSubmit() {
      if (this.tableParam?.time?.length) {
        this.tableParam.createTime = this.tableParam.time[0];
        this.tableParam.updateTime = this.tableParam.time[1];
      } else {
        this.tableParam.createTime = "";
        this.tableParam.updateTime = "";
      }
      if (this.tableParam?.time2?.length) {
        this.tableParam.field1 = this.tableParam.time2[0];
        this.tableParam.field2 = this.tableParam.time2[1];
      } else {
        this.tableParam.field1 = "";
        this.tableParam.field2 = "";
      }
      this.gettableData();
    },
    handleVideo(url) {
      if (!url) {
        this.$message.warning("图片为空");
        return;
      }
      let items = url.split(",").map(res => "/file/" + res);
      this.imgList = items;
      // this.imgList = items.filter(res => res.includes("type=img"));
      // this.mp4List = items.filter(res => res.includes("type=mp4"));
      this.imgsDialog = true;
    },
    checkOutIn(row) {
      this.remark = "";
      this.low = row;
      this.checkInForm = this.$options.data().checkInForm;
      this.visible = true;
    },
    /**
     * @Description: 查看数据详情
     * @Param:
     * @Author: wangwangwang
     */
    handleDetails(data) {
      this.lookVisible = true;
      this.lookConfig = data;
      // ----------------------------------- 分割线（上面为新逻辑）-------------------------------------------
      //   const params = {
      //     pid: data.id,
      //   }
      //   this.remark = data.handleDetails;
      //   getCheckResult(params).then(res => {
      //     if (res.code === 1001) {
      //       this.checkOutData = data;
      //       this.visible = true;
      //       this.readOnly = true;
      //       this.tableNav = res.data.title; // 表头数据
      //       const newData = res.data.list.map(item => {
      //         item.unshift({
      //           testItem: item[0].testItem
      //         })
      //         return item
      //       });
      //       this.dataSource = newData; // 表单数据
      //       this.tableNav.unshift({
      //         NAME: "验收项目"
      //       })
      //     }
      //   })
    },
    checkInSubmit() {
      this.$refs["checkInForm"].validate(valid => {
        if (valid) {
          let obj = {
            remark: this.checkInForm.remark,
            imgs: this.listFilesa.length > 0 ? this.listFilesa[0].path : "",
            pid: this.low.id,
            handling: "",
            outcome: "OK",
            isQualified: "",
            concreteDetectionValue: this.checkInForm,
          };
          // if (this.low.buildSize === 2) {
          //   //试件尺寸id '1':非标准试件尺寸100×100×100 '2':标准试件尺寸150×150×150
          //   obj["sizeId"] = "2";
          //   //试件尺寸
          //   obj["sizeValue"] = "150mm*150mm*150mm";
          // } else {
          //   //试件尺寸id '1':非标准试件尺寸100×100×100 '2':标准试件尺寸150×150×150
          //   obj["sizeId"] = "1";
          //   //试件尺寸
          //   obj["sizeValue"] = "100mm*100mm*100mm";
          // }
          concreteSaveResult(obj).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功");
              this.visible = false;
              this.searchSubmit();
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * @Description: 结果为OK点击确定改变状态
     * @Param:
     * @Author: wangwangwang
     */
    handleSure() {
      const copyData = JSON.parse(JSON.stringify(this.tableNav));
      copyData.shift();
      const params = {
        id: this.checkOutData.id,
        typeId: this.checkOutData.detectionTypeId,
        claim: copyData,
        remark: this.remark,
        outcome: "OK",
        list: this.dataSource,
        type: 2,
      };
      /**
       * @Description: 录入检测结果、如果结果为NG 则流程
       * @Param:
       * @Author: wangwangwang
       */
      saveCheckOutResult(params).then(res => {
        if (res.code === 1001) {
          this.visible = false;
          this.result = res.data;
          this.dialogVisible = false;
          this.$message.success("检测已录入");
          this.gettableData();
        }
      });
    },
    /**
     * @Description: 结果为NG进入审核
     * @Param:
     * @Author: wangwangwang
     */
    handleToFlow() {
      const params = {
        station: this.checkOutData.station,
        engineeringName: this.checkOutData.engineeringName,
        product: this.checkOutData.product,
        detectionTypeId: this.checkOutData.detectionTypeId,
        stationId: this.checkOutData.stationId,
        productId: this.checkOutData.productId,
        carNo: this.checkOutData.carNo,
        contractId: this.checkOutData.contractId,
        id: this.checkOutData.id,
        type: 1,
        flowsType: 1, // 出场检测
        tableTitle: JSON.stringify(this.tableNav),
        tableDataSource: JSON.stringify(this.dataSource),
      };
      this.dialogVisible = false;
      this.$router.push({ name: "checkflows2", query: params });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.listFilesa.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.listFilesa = [];
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
      };
      this.listFilesa.push(item);
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 10px 0 20px 0;
  font-weight: bold;
}

.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
